import { render, staticRenderFns } from "./InfoView_FAQ.vue?vue&type=template&id=5dbb6b10&"
import script from "./InfoView_FAQ.vue?vue&type=script&lang=js&"
export * from "./InfoView_FAQ.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports